import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=15a3d363&scoped=true"
import script from "./FooterComponent.js?vue&type=script&lang=js&external"
export * from "./FooterComponent.js?vue&type=script&lang=js&external"
import style0 from "./FooterComponent.scss?vue&type=style&index=0&id=15a3d363&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a3d363",
  null
  
)

export default component.exports